'use strict';
var FeedbackController = /** @class */ (function () {
    /*@ngInject*/
    function FeedbackController(Auth, $state, $scope, $location) {
    }
    return FeedbackController;
}());
export default FeedbackController;
//# sourceMappingURL=feedback.controller.js.map